import { Link } from 'react-router-dom';
import { logisticsCityPath } from '../../content/seoUrlManifest';
import { ArrowIcon, Clipboard, Coin, MapPin, Parcel, Phone, Pills, Scooter, Shop, Whistle } from './ClayShapes';
import { clayName } from './ClayIcon';
import PlatformReveal3D from './PlatformReveal3D';
import ClayIcon from './ClayIcon';
import { BeforeAfter, CapabilityMarquee, Ecosystem, ProductTour } from './HomeSections';
import { whatsappLink } from '../../content/siteContent';

const cities = [
  { name: 'Surat', status: '● LIVE · HQ', tone: 'live', to: logisticsCityPath('surat') },
  { name: 'Ahmedabad', status: '● LIVE', tone: 'live', to: logisticsCityPath('ahmedabad') },
  { name: 'Pune', status: '● LIVE', tone: 'live', to: logisticsCityPath('pune') },
  { name: 'Mumbai', status: '● EXPANDING NOW', tone: 'soon', to: logisticsCityPath('mumbai') },
];

function Stat({ to, suffix, label, swatch }) {
  return (
    <div className="glass gs-card lift" style={{ borderRadius: 24, padding: 22, display: 'flex', alignItems: 'center', gap: 16 }}>
      {swatch}
      <div>
        <div className="gs-count fw-display" data-to={to} data-suffix={suffix} style={{ fontSize: 36, fontWeight: 800, lineHeight: 1 }}>
          {`${to}${suffix}`}
        </div>
        <div style={{ fontSize: 14, color: 'var(--muted)', marginTop: 4 }}>{label}</div>
      </div>
    </div>
  );
}

export default function HomeExperience() {
  return (
    <div className="fw-home">
      <section id="top" className="gs-heroarea fw-wrap hero-grid" style={{ paddingTop: 64, paddingBottom: 40 }}>
        <div className="hero-copy">
          <div className="glass gs-hero fw-mono" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, padding: '8px 16px', borderRadius: 999, fontSize: 12, color: '#2B3756' }}>
            <span style={{ width: 9, height: 9, borderRadius: '50%', background: '#1FBF7A', boxShadow: '0 0 0 4px rgba(31,191,122,.2)' }} />
            Now onboarding distributors in Mumbai
          </div>
          <h1 className="fw-h1 gs-hero">
            Medicines move <span className="hl">faster</span> when every rider is on the map.
          </h1>
          <p className="fw-sub gs-hero" style={{ maxWidth: 540, margin: '22px 0 0' }}>
            FastWhistle is the delivery partner and the fleet software for medicine distributors. Our riders deliver same-day in Surat, Ahmedabad, Pune and Mumbai — or run your own team with our app, anywhere in India.
          </p>
          <div className="gs-hero" style={{ display: 'flex', flexWrap: 'wrap', gap: 14, marginTop: 30 }}>
            <Link to="/contact-us" className="clay btn btn-mag" style={primaryBtn}>
              Start delivering <ArrowIcon />
            </Link>
            <a href="#platform" className="glass btn" style={glassBtn}>See how it works</a>
          </div>
          <ul className="hero-proof gs-hero" aria-label="Highlights">
            <li><span style={{ background: '#1FBF7A' }} />Same-day delivery</li>
            <li><span style={{ background: '#3462F2' }} />Live GPS tracking</li>
            <li><span style={{ background: '#FFB547' }} />Collections reconciled</li>
            <li>
              <a href={whatsappLink()} target="_blank" rel="noopener noreferrer">WhatsApp us →</a>
            </li>
          </ul>
        </div>

        <div className="hero-vis" aria-hidden="true">
          <div className="hero-stage">
            <div className="f2 gs-pop gs-par" data-depth="18" style={{ position: 'absolute', left: -6, top: 70, zIndex: 1 }}>
              <Parcel />
            </div>
            <div className="f3 gs-pop gs-par" data-depth="26" style={{ position: 'absolute', right: 0, top: 330, zIndex: 1 }}>
              {clayName('whistle') ? <Whistle size={130} /> : <Pills />}
            </div>
            <div className="glass tilt3d gs-panel" style={{ position: 'absolute', left: 70, top: 110, width: 400, zIndex: 2, borderRadius: 28, padding: 20, boxSizing: 'border-box' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="fw-mono" style={{ fontSize: 12, color: '#2B3756' }}>● LIVE · SURAT ZONE</span>
                <span className="fw-mono" style={{ fontSize: 11, color: 'var(--muted)', padding: '4px 10px', borderRadius: 999, background: 'rgba(255,255,255,.6)' }}>Sample</span>
              </div>
              <div className="map-grid" style={{ position: 'relative', height: 180, marginTop: 14, borderRadius: 18, overflow: 'hidden' }}>
                <svg width="360" height="180" viewBox="0 0 360 180" style={{ position: 'absolute', left: 0, top: 0 }}>
                  <path className="route" d="M 20 150 L 120 150 L 120 80 L 250 80 L 250 34 L 340 34" fill="none" stroke="#F09A1A" strokeWidth="4" strokeLinecap="round" />
                </svg>
                <div className="clay-soft" style={{ position: 'absolute', left: 8, top: 136, width: 26, height: 26, borderRadius: 8, background: '#3462F2' }} />
                <div className="clay-soft" style={{ position: 'absolute', left: 328, top: 20, width: 26, height: 26, borderRadius: 8, background: '#1FBF7A' }} />
                <div className="rider" />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 16 }}>
                <span className="clay-soft fw-mono" style={{ width: 40, height: 40, borderRadius: 14, background: '#FFB547', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600, color: '#5A3A00' }}>07</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>Distributor → Chemist</div>
                  <div style={{ height: 8, borderRadius: 6, background: 'rgba(11,21,48,.08)', marginTop: 8 }}>
                    <div style={{ width: '64%', height: 8, borderRadius: 6, background: '#F09A1A' }} />
                  </div>
                </div>
                <span className="fw-mono" style={{ fontSize: 13, fontWeight: 500, color: '#8A5300' }}>ETA 18m</span>
              </div>
            </div>
            <div className="f1 gs-pop gs-par" data-depth="34" style={{ position: 'absolute', right: 30, top: 40, zIndex: 3 }}>
              <MapPin />
            </div>
            <div className="f3 gs-pop gs-par" data-depth="30" style={{ position: 'absolute', left: 10, top: 420, zIndex: 3 }}>
              <Scooter />
            </div>
            <div className="f2 gs-pop gs-par" data-depth="22" style={{ position: 'absolute', right: 60, top: 470, zIndex: 3 }}>
              <Coin />
            </div>
            <div className="glass f1 gs-pop gs-par" data-depth="12" style={{ position: 'absolute', left: 250, top: 30, zIndex: 4, borderRadius: 18, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
              <span className="clay-soft" style={{ width: 30, height: 30, borderRadius: '50%', background: '#1FBF7A', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12l5 5 9-10" /></svg>
              </span>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>Delivered</div>
                <div style={{ fontSize: 12, color: 'var(--muted)' }}>Chemist · Adajan</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fw-wrap" style={{ paddingTop: 8, paddingBottom: 32 }}>
        <div className="fw-grid-stats">
          <Stat to="50" suffix="+" label="riders on the road" swatch={<div className="clay-soft squish" style={{ width: 52, height: 52, borderRadius: 18, background: '#3462F2', flex: 'none' }} />} />
          <Stat to="70" suffix="+" label="distributors served" swatch={<div className="clay-soft squish" style={{ width: 52, height: 52, borderRadius: 18, background: '#F2B66B', flex: 'none' }} />} />
          <Stat to="4" suffix="" label="cities live" swatch={<div style={{ width: 52, height: 52, flex: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div className="clay-soft" style={{ width: 44, height: 44, borderRadius: '50% 50% 50% 0', transform: 'rotate(-45deg)', background: '#FFB547' }} /></div>} />
          <div className="glass gs-card lift" style={{ borderRadius: 24, padding: 22, display: 'flex', alignItems: 'center', gap: 16 }}>
            <div className="clay-soft squish" style={{ width: 52, height: 52, borderRadius: '50%', background: '#1FBF7A', flex: 'none' }} />
            <div>
              <div className="fw-display" style={{ fontSize: 36, fontWeight: 800, lineHeight: 1 }}>3-in-1</div>
              <div style={{ fontSize: 14, color: 'var(--muted)', marginTop: 4 }}>app for riders, salesmen &amp; staff</div>
            </div>
          </div>
        </div>
        <CapabilityMarquee />
      </section>

      <section id="logistics" className="fw-wrap" style={{ paddingTop: 88, paddingBottom: 32 }}>
        <div className="fw-eyebrow gs-up">What we do</div>
        <h2 className="fw-h2 gs-up" style={{ maxWidth: 760 }}>
          Pharma distribution, <span className="hl">two ways</span> to run it.
        </h2>
        <div className="fw-grid-2" style={{ marginTop: 44 }}>
          <article className="glass gs-card lift" style={wayCard}>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
              <span className="clay-soft fw-mono" style={{ fontSize: 12, padding: '8px 14px', borderRadius: 999, background: '#3462F2', color: '#fff' }}>01 · LOGISTICS</span>
              <span style={{ fontSize: 13, color: 'var(--muted)' }}>Ahmedabad · Surat · Pune · Mumbai</span>
            </div>
            <div style={{ height: 180, margin: '20px 0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ position: 'relative', width: 190, height: 150 }}>
                <div className="f2" style={{ position: 'absolute', left: 10, top: 30 }}>{clayName('truck') ? <img className="clay-icon" src="/icons/clay/truck.webp" alt="" width="150" height="150" style={{ width: 150, height: 150 }} /> : <Parcel size={130} />}</div>
                <div className="f1" style={{ position: 'absolute', left: 120, top: 0 }}><MapPin size={58} /></div>
              </div>
            </div>
            <h3 className="fw-display" style={{ fontSize: 'clamp(24px, 2.6vw, 30px)', fontWeight: 700, letterSpacing: '-0.02em', margin: 0 }}>Our riders, your deliveries.</h3>
            <p className="fw-sub" style={{ fontSize: 17, margin: '12px 0 0' }}>Same-day medicine delivery from your godown to every chemist on the route.</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 'auto', paddingTop: 24 }}>
              <span className="chip">Same-day</span>
              <span className="chip">Trained riders</span>
              <span className="chip">Live tracking</span>
            </div>
            <Link to="/logistics" className="lnk" style={{ marginTop: 16 }}>Get a delivery quote →</Link>
          </article>

          <article className="glass gs-card lift" style={wayCard}>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
              <span className="clay-soft fw-mono" style={{ fontSize: 12, padding: '8px 14px', borderRadius: 999, background: '#FFB547', color: '#3D2600' }}>02 · FLEET SAAS</span>
              <span style={{ fontSize: 13, color: 'var(--muted)' }}>Anywhere in India</span>
            </div>
            <div style={{ height: 180, margin: '20px 0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ position: 'relative', width: 190, height: 180 }}>
                <div className="f1" style={{ position: 'absolute', left: 40, top: 4 }}><Phone /></div>
                <div className="f3" style={{ position: 'absolute', left: 124, top: 104 }}><Coin size={62} /></div>
              </div>
            </div>
            <h3 className="fw-display" style={{ fontSize: 'clamp(24px, 2.6vw, 30px)', fontWeight: 700, letterSpacing: '-0.02em', margin: 0 }}>Your team, our software.</h3>
            <p className="fw-sub" style={{ fontSize: 17, margin: '12px 0 0' }}>Tasks, live tracking, attendance and collections for your own field team.</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 'auto', paddingTop: 24 }}>
              <span className="chip">Tasks</span>
              <span className="chip">Tracking</span>
              <span className="chip">Attendance</span>
              <span className="chip">Collections</span>
            </div>
            <Link to="/fleet-saas" className="lnk" style={{ marginTop: 16, color: '#8A5300' }}>Explore Fleet SaaS →</Link>
          </article>
        </div>
        <p className="gs-up" style={{ fontSize: 15, color: 'var(--muted)', margin: '22px 0 0' }}>
          Not sure which fits? <Link to="/compare/logistics-vs-fleet-saas">Compare Logistics vs Fleet SaaS</Link>
        </p>
      </section>

      <PlatformReveal3D />

      <section id="how" className="fw-wrap" style={{ paddingTop: 88, paddingBottom: 88 }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'flex-end', gap: 20 }}>
          <div style={{ flex: '1 1 420px', minWidth: 0 }}>
            <div className="fw-eyebrow gs-up">The workflow</div>
            <h2 className="fw-h2 gs-up" style={{ maxWidth: 700 }}>From order to collection, tracked at every step.</h2>
          </div>
          <p className="fw-sub gs-up" style={{ flex: '0 1 380px', margin: 0 }}>Every parcel and every rupee has a status. Distributors see it live.</p>
        </div>
        <ol className="fw-grid-steps">
          <Step n="01" title="Order lands" text="Orders are assigned to the right rider for each zone." icon={<Clipboard />} />
          <Step n="02" title="Pickup" text="Rider collects the packed invoice batch from the distributor." icon={<ClayIcon name="pickup" size={110} fallback={<Parcel size={92} />} />} />
          <Step n="03" title="En route" text="Live location on the map — every rider moving." icon={<MapPin size={100} />} />
          <Step n="04" title="Delivered" text="Chemist receives the stock. Delivery is marked in the app." icon={<ClayIcon name="delivered" size={110} fallback={<Shop />} />} />
          <Step n="05" title="Collection" text="Payments collected on delivery are recorded and reconciled." icon={<Coin size={80} />} />
        </ol>
      </section>

      <ProductTour />

      <section id="saas" className="fw-wrap" style={{ paddingTop: 56, paddingBottom: 88 }}>
        <div className="glass gs-up" style={{ borderRadius: 40, padding: 'clamp(24px, 5vw, 64px)', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 48 }}>
          <div style={{ flex: '1 1 340px', minWidth: 0 }}>
            <div className="fw-eyebrow">Fleet SaaS</div>
            <h2 className="fw-h2" style={{ fontSize: 'clamp(30px, 4vw, 50px)' }}>One screen for your whole field team.</h2>
            <p className="fw-sub" style={{ fontSize: 18, margin: '16px 0 0' }}>Built for medicine distributors who run their own riders and salesmen.</p>
            <ul style={{ listStyle: 'none', padding: 0, margin: '28px 0 0', display: 'flex', flexDirection: 'column', gap: 16 }}>
              <Feature color="#3462F2" ink="#fff" mark="✓" icon="clipboard" title="Tasks" text="Assign deliveries and visits, see what's pending." />
              <Feature color="#FFB547" ink="#3D2600" mark="⌖" icon="binoculars" title="Live tracking" text="Every rider on one map, in real time." />
              <Feature color="#6D5AD8" ink="#fff" mark="▦" icon="user-check" title="Attendance" text="Check-in, leave and working hours without registers." />
              <Feature color="#138A57" ink="#fff" mark="₹" icon="coin" title="Collections" text="Cash and cheque on the route, reconciled daily." />
            </ul>
            <Link to="/contact-us" className="clay btn btn-mag" style={{ ...primaryBtn, background: '#0B1530', marginTop: 32 }}>
              Request a Fleet SaaS demo <ArrowIcon />
            </Link>
          </div>
          <Dashboard />
        </div>
      </section>

      <section id="cities" className="fw-wrap" style={{ paddingTop: 56, paddingBottom: 56 }}>
        <div className="fw-eyebrow gs-up">Where we deliver</div>
        <h2 className="fw-h2 gs-up">Four cities. Riders on the ground.</h2>
        <div className="fw-grid-cities" style={{ marginTop: 40 }}>
          {cities.map((city) => (
            <Link
              key={city.name}
              to={city.to}
              className={`${city.tone === 'soon' ? 'clay' : 'glass'} gs-card lift`}
              style={{
                textDecoration: 'none',
                color: 'var(--ink)',
                borderRadius: 28,
                padding: 26,
                display: 'flex',
                flexDirection: 'column',
                gap: 32,
                background: city.tone === 'soon' ? '#FFB547' : undefined,
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="fw-mono" style={{ fontSize: 12, color: city.tone === 'soon' ? '#4A3000' : '#0E7A4E' }}>{city.status}</span>
                <span className="clay-soft" style={{ width: 32, height: 32, borderRadius: '50% 50% 50% 0', transform: 'rotate(-45deg)', background: city.tone === 'soon' ? '#0B1530' : '#3462F2' }} />
              </div>
              <span className="fw-display" style={{ fontSize: 34, fontWeight: 800, letterSpacing: '-0.02em' }}>{city.name}</span>
            </Link>
          ))}
        </div>
        <p className="gs-up" style={{ fontSize: 15, color: 'var(--muted)', margin: '20px 0 0' }}>Fleet SaaS works anywhere in India — your team, any city.</p>
      </section>

      <Ecosystem />

      <BeforeAfter />

      <section id="faq" className="fw-wrap" style={{ padding: '56px 24px' }}>
        <div className="glass gs-up" style={{ borderRadius: 36, padding: 'clamp(24px, 5vw, 56px)', display: 'flex', flexWrap: 'wrap', gap: '32px 40px' }}>
          <div style={{ flex: '1 1 260px', minWidth: 0 }}>
            <div className="fw-eyebrow">FAQ</div>
            <h2 className="fw-h2" style={{ fontSize: 'clamp(28px, 3.4vw, 44px)' }}>Asked on the first call</h2>
          </div>
          <div style={{ flex: '2 1 440px', minWidth: 0 }}>
            <Faq open q="Logistics or Fleet SaaS — which one do I need?" a="Logistics if you want FastWhistle riders to deliver for you. Fleet SaaS if you already have your own delivery team and want tasks, tracking, attendance and collections." />
            <Faq q="Can I use both?" a="Yes. Many distributors use Logistics for outsourced delivery in our live cities and Fleet SaaS for their own salesmen and staff anywhere in India." />
            <Faq q="Which cities do you deliver in?" a="Our riders deliver in Ahmedabad, Surat, Pune and Mumbai. Mumbai is expanding now. Fleet SaaS works anywhere in India." />
            <Faq q="Does it work with my accounting software?" a="Fleet SaaS syncs parties, products, orders and outstandings from ZeroMDS and compatible accounting software, so your team does not re-enter data." />
            <Faq q="Is FastWhistle a medicine delivery app for patients?" a="No. FastWhistle is B2B — we deliver pharma parcels from distributors to chemists, clinics and stockists." />
            <Faq q="Who runs FastWhistle?" a="FastWhistle is operated by 5INCH VENTURES PRIVATE LIMITED, headquartered in Surat." last />
          </div>
        </div>
      </section>

      <section id="contact" className="fw-wrap" style={{ padding: '40px 24px 88px' }}>
        <div className="clay gs-up" style={{ position: 'relative', borderRadius: 40, background: '#3462F2', color: '#fff', padding: 'clamp(32px, 6vw, 72px)', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 32 }}>
          <div className="f1 hide-sm" style={{ position: 'absolute', right: '8%', top: -44 }} aria-hidden="true">
            {clayName('whistle') ? <Whistle size={96} /> : <MapPin size={66} />}
          </div>
          <div style={{ flex: '1 1 380px', minWidth: 0, maxWidth: 620 }}>
            <h2 className="fw-display" style={{ fontWeight: 800, fontSize: 'clamp(30px, 4.6vw, 58px)', letterSpacing: '-0.03em', lineHeight: 1.04, margin: 0 }}>
              Put your deliveries on the map this week.
            </h2>
            <p style={{ fontSize: 18, lineHeight: 1.55, color: '#E8EEFF', margin: '16px 0 0' }}>
              A 20-minute call with our team. You leave with a plan for your routes and a quote.
            </p>
          </div>
          <div style={{ flex: '0 1 300px', display: 'flex', flexDirection: 'column', gap: 12 }}>
            <a href="tel:+916357017016" className="clay-soft btn btn-mag" style={{ ...primaryBtn, background: '#fff', color: '#0B1530' }}>
              Call +91 63570 17016
            </a>
            <Link to="/contact-us" className="glass btn" style={{ ...glassBtn, color: '#fff', background: 'rgba(255,255,255,.16)' }}>
              Book a demo
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

function Step({ n, title, text, icon }) {
  return (
    <li className="glass gs-card lift center-sm" style={{ position: 'relative', borderRadius: 28, padding: 24, textAlign: 'center' }}>
      <ClayIcon name={`num-${Number(n)}`} size={40} alt="" className="step-digit" />
      <div className="gs-icon" style={{ height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</div>
      <div className="fw-mono" style={{ fontSize: 12, color: 'var(--muted)' }}>STEP {n}</div>
      <h3 className="fw-display" style={{ fontSize: 22, margin: '6px 0 0' }}>{title}</h3>
      <p style={{ fontSize: 15, lineHeight: 1.5, color: 'var(--ink-2)', margin: '8px 0 0' }}>{text}</p>
    </li>
  );
}

function Feature({ color, ink, mark, icon, title, text }) {
  return (
    <li className="gs-li" style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
      <ClayIcon
        name={icon}
        size={44}
        fallback={<span className="clay-soft fw-display" style={{ flex: 'none', width: 36, height: 36, borderRadius: 12, background: color, color: ink, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800 }}>{mark}</span>}
      />
      <div>
        <strong style={{ fontWeight: 600 }}>{title}</strong>
        <div style={{ color: 'var(--ink-2)', fontSize: 15, marginTop: 2 }}>{text}</div>
      </div>
    </li>
  );
}

function Faq({ q, a, last, open }) {
  return (
    <details className={`faq-item${last ? ' is-last' : ''}`} open={open}>
      <summary>
        <h3>{q}</h3>
        <span className="faq-plus" aria-hidden="true" />
      </summary>
      <p>{a}</p>
    </details>
  );
}

function Dashboard() {
  return (
    <div className="gs-scrub" style={{ flex: '1.3 1 460px', minWidth: 0, position: 'relative', display: 'flex', justifyContent: 'center', padding: '30px 0' }}>
      <div className="f1 hide-sm" style={{ position: 'absolute', left: -8, top: -6, zIndex: 3 }} aria-hidden="true">
        <MapPin size={80} />
      </div>
      <div className="glass-dark tilt-dash" style={{ position: 'relative', zIndex: 2, width: '100%', maxWidth: 600, borderRadius: 26, color: '#EEF2FA', overflow: 'hidden', display: 'flex' }}>
        <div className="dash-side" style={{ width: 140, flex: 'none', borderRight: '1px solid rgba(255,255,255,.12)', padding: '18px 12px', display: 'flex', flexDirection: 'column', gap: 6, fontSize: 13 }}>
          <div className="fw-display" style={{ fontWeight: 700, fontSize: 15, padding: '0 8px 12px' }}>FastWhistle</div>
          <div style={{ padding: '9px 10px', borderRadius: 10, color: '#C1CAE0' }}>Tasks</div>
          <div style={{ padding: '9px 10px', borderRadius: 10, background: 'rgba(255,255,255,.14)', color: '#fff' }}>Live tracking</div>
          <div style={{ padding: '9px 10px', borderRadius: 10, color: '#C1CAE0' }}>Attendance</div>
          <div style={{ padding: '9px 10px', borderRadius: 10, color: '#C1CAE0' }}>Collections</div>
        </div>
        <div style={{ flex: 1, minWidth: 0, padding: 18, display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div className="fw-mono" style={{ display: 'flex', justifyContent: 'space-between', gap: 8, fontSize: 11, color: '#C1CAE0' }}>
            <span>LIVE · ALL ZONES</span><span>Sample data</span>
          </div>
          <div className="dash-kpis">
            <Kpi label="On duty" value="[00]" />
            <Kpi label="Tasks done" value="[00]" color="#7CF0BC" />
            <Kpi label="Collected" value="₹[0.0L]" color="#FFC77A" />
          </div>
          <div style={{ position: 'relative', height: 150, borderRadius: 16, backgroundColor: 'rgba(255,255,255,.06)', backgroundImage: 'linear-gradient(rgba(255,255,255,.07) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.07) 1px, transparent 1px)', backgroundSize: '26px 26px', overflow: 'hidden' }}>
            <svg width="100%" height="150" viewBox="0 0 400 150" preserveAspectRatio="none" style={{ position: 'absolute', inset: 0 }}>
              <path className="route" d="M 20 120 L 120 120 L 120 60 L 260 60 L 260 26 L 380 26" fill="none" stroke="#FFB547" strokeWidth="3" />
            </svg>
          </div>
          <DashRow name="Rider 07 · Varachha" tag="En route" tagBg="rgba(255,181,71,.2)" tagColor="#FFD596" />
          <DashRow name="Rider 12 · Adajan" tag="Delivered" tagBg="rgba(61,220,151,.2)" tagColor="#8CF0C2" />
        </div>
      </div>
      <div className="f2 hide-sm" style={{ position: 'absolute', right: -4, bottom: 4, zIndex: 3 }} aria-hidden="true">
        <Coin size={72} />
      </div>
    </div>
  );
}

function Kpi({ label, value, color }) {
  return (
    <div style={{ padding: 12, borderRadius: 14, background: 'rgba(255,255,255,.08)' }}>
      <div style={{ fontSize: 11, color: '#C1CAE0' }}>{label}</div>
      <div className="fw-display" style={{ fontSize: 22, fontWeight: 700, color }}>{value}</div>
    </div>
  );
}

function DashRow({ name, tag, tagBg, tagColor }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, padding: '10px 12px', borderRadius: 12, background: 'rgba(255,255,255,.08)', fontSize: 13 }}>
      <span>{name}</span>
      <span style={{ fontSize: 11, padding: '4px 9px', borderRadius: 999, background: tagBg, color: tagColor, whiteSpace: 'nowrap' }}>{tag}</span>
    </div>
  );
}

const primaryBtn = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 10,
  minHeight: 56,
  padding: '0 28px',
  borderRadius: 999,
  background: '#3462F2',
  color: '#fff',
  textDecoration: 'none',
  fontWeight: 600,
  fontSize: 16,
};

const glassBtn = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 56,
  padding: '0 26px',
  borderRadius: 999,
  color: '#0B1530',
  textDecoration: 'none',
  fontWeight: 600,
  fontSize: 16,
};

const wayCard = {
  position: 'relative',
  borderRadius: 32,
  padding: 'clamp(24px, 4vw, 36px)',
  display: 'flex',
  flexDirection: 'column',
};
